import { createFileRoute } from '@tanstack/react-router';
import { AuthGate } from '../features/auth/auth-gate.js';
import { VocabEditor } from '../features/media/vocab-editor.js';

function AdminMediaVocabPage() {
  return (
    <AuthGate roles={['admin']}>
      <VocabEditor />
    </AuthGate>
  );
}

export const Route = createFileRoute('/app/admin/media-vocab')({
  component: AdminMediaVocabPage,
});
